import { render, staticRenderFns } from "./SisViewDialog.vue?vue&type=template&id=f945f490&scoped=true"
import script from "./SisViewDialog.vue?vue&type=script&lang=js"
export * from "./SisViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f945f490",
  null
  
)

export default component.exports